import { useNotificationsRequest } from "../../apis/notifications/useNotificationsRequest";


export const useNotificationsHandlers = () => {

    const { markAsRead, deleteNotification } = useNotificationsRequest()

    const markAsReadHandler = async (payload: any) => {
        await markAsRead(payload)
    }

    const deleteNotificationHandler = async (id: any) => {
        await deleteNotification(id)
    }

    return {
        markAsReadHandler,
        deleteNotificationHandler
    };
}
